import { env } from 'utils/env';

export const api = {
	url: env.APP_API_URL,
	timeout: +env.APP_API_TIMEOUT || 10000,
	logEnabled: env.APP_API_LOG_ENABLED === 'true',
	useMock: env.APP_API_USE_MOCK === 'true',
};
